import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=aa52b854&scoped=true&"
import script from "./menuItem.vue?vue&type=script&lang=js&"
export * from "./menuItem.vue?vue&type=script&lang=js&"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=aa52b854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa52b854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa52b854')) {
      api.createRecord('aa52b854', component.options)
    } else {
      api.reload('aa52b854', component.options)
    }
    module.hot.accept("./menuItem.vue?vue&type=template&id=aa52b854&scoped=true&", function () {
      api.rerender('aa52b854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/menuItem.vue"
export default component.exports